import React, {ReactElement, useState} from 'react';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';
import {IQuestionElementProps} from '../../../../incase-domain/elements/base/questionElementBase';
import {IElementQuestion} from '../../../../incase-domain/elements/question/question';
import QuestionLayout from '../common/QuestionLayout';
import QuestionAnswer from './QuestionAnswer';
import {getAnswerStyles} from '../common/getStyles';
import {getAnswerType} from '../common/utils';

function QuestionElement(props: IQuestionElementProps<IElementQuestion>): ReactElement {
    const {element, device = DeviceType.DESKTOP} = props;
    const [openCommentIndex, setOpenCommentIndex] = useState<number | null>(null);

    return (
        <QuestionLayout element={element} device={device} showConfirmButton>
            <div className={`c-questionElement ${device === DeviceType.MOBILE ? 'c-questionElement--mobile' : ''}`}>
                {element.answers.map((answer, index) => (
                    <QuestionAnswer
                        key={`question-answer-${element.id}-${index}`}
                        answer={answer.text}
                        answerType={getAnswerType(answer)}
                        comment={answer.comment}
                        leadingIcon="checkbox"
                        correctColor={element.correctColor}
                        incorrectColor={element.incorrectColor}
                        debatableColor={element.debatableColor}
                        styles={getAnswerStyles(device, element)}
                        onClick={() => {
                            if (answer.comment) {
                                setOpenCommentIndex(openCommentIndex === index ? null : index);
                            } else {
                                setOpenCommentIndex(null);
                            }
                        }}
                        showComment={openCommentIndex === index}
                        setShowComment={(show) => {
                            if (answer.comment) {
                                setOpenCommentIndex(show ? index : null);
                            }
                        }}
                        writeAnswerIndices={element.writeAnswerIndices}
                        index={index}
                    />
                ))}
            </div>
        </QuestionLayout>
    );
}

export default QuestionElement;
